<script setup lang="ts">
import EnglishLessonPage from "~/features/english/components/EnglishLessonPage.vue";

const textbookAlignedPoints = [
  "Unit Hazrat Muhammad (SAW) ko final Prophet, ideal leader aur universal guide ke tor par present karta hai.",
  "Lesson me truthfulness, justice, mercy, patience aur equality jesi qualities ko central importance di gayi hai.",
  "Exam prep me character, mission, social reform aur final sermon ke message ko clear headings me samajhna useful hota hai.",
];

const chapterCoverage = [
  "Early life aur orphanhood",
  "Al-Sadiq aur Al-Amin ke titles",
  "Marriage to Hazrat Khadijah (RA)",
  "Hilf al-Fudul aur Hajar-e-Aswad dispute",
  "Cave Hira aur first revelation",
  "Persecution, Hijrah aur Madinah society",
  "Madinah me brotherhood aur charter-based order",
  "Conquest of Makkah aur forgiveness",
  "Farewell Sermon ka equality-based message",
];

const quickRevisionPoints = [
  "571 AD me Makkah me paida hue.",
  "Honesty ki wajah se Al-Sadiq aur Al-Amin ke titles mile.",
  "Hazrat Khadijah (RA) ke sath marriage ne stability aur support provide ki.",
  "Hilf al-Fudul me oppressed logon ke support ka principle nazar aata hai.",
  "Cave Hira me first revelation se Prophethood ka aghaz hua.",
  "Hijrah ke baad Madinah me brotherhood aur justice par mabni society bani.",
  "Farewell Sermon me equality, dignity aur brotherhood ka universal message diya gaya.",
];

const sourceBackedFocus = [
  "Secondary solved-note sources consistently early life, Al-Sadiq / Al-Amin, Hira, Hijrah, conquest of Makkah aur Farewell Sermon ko core exam areas ke tor par repeat karti hain.",
  "Unit 1 ke answer me sirf spiritual side nahi, social reform aur practical leadership bhi cover karna important hota hai.",
  "Madinah phase ko ignore karne se answer incomplete lag sakta hai, kyun ke yahin teachings social order me visibly turn hoti hain.",
];

const readingQuestions = [
  {
    question: "What important facts of the Prophet's early life are relevant in this lesson?",
    answer: "Lesson ke context me aap (SAW) ka early life simplicity, orphanhood, dignity aur strong character ke sath jura hua hai. Aap Makkah me paida hue, bachpan me personal losses face kiye, magar in experiences ne aap ki maturity aur compassion ko aur gehra banaya.",
  },
  {
    question: "Why were the titles Al-Sadiq and Al-Amin important before Prophethood?",
    answer: "Yeh titles proof thay ke log bhi Prophethood se pehle aap (SAW) ki honesty aur trustworthiness ko recognize karte thay. Is se lesson ka yeh point strong hota hai ke aap ka moral character pehle hi society me established tha.",
  },
  {
    question: "What qualities of Rasoolullah (SAW) are highlighted in the lesson?",
    answer: "Lesson me Rasoolullah (SAW) ki truthfulness, honesty, justice, mercy, patience, humility aur compassion ko highlight kiya gaya hai. Inhi qualities ki wajah se log aap ko Al-Sadiq aur Al-Amin ke titles se yaad karte thay.",
  },
  {
    question: "What do Hilf al-Fudul and the Hajar-e-Aswad incident show about the Prophet's personality?",
    answer: "Dono incidents yeh dikhate hain ke Rasoolullah (SAW) fairness, peace-making aur justice ko value karte thay. Hilf al-Fudul oppressed ke support ka example hai, jab ke Hajar-e-Aswad dispute me aap ki wisdom aur balanced leadership nazar aati hai.",
  },
  {
    question: "Why is the marriage to Hazrat Khadijah (RA) important in the lesson's broader understanding of the Prophet's life?",
    answer: "Yeh marriage stability, dignity aur emotional support ka important phase show karti hai. Hazrat Khadijah (RA) ne early mission ke difficult period me trust aur support provide ki, jo prophetic struggle ko samajhne me relevant hai.",
  },
  {
    question: "Why is Cave Hira important in understanding the lesson?",
    answer: "Cave Hira reflection, spiritual seriousness aur revelation ke beginning point ki wajah se important hai. Yahin se first wahi aayi aur prophetic mission formally start hua.",
  },
  {
    question: "Why is Hazrat Muhammad (SAW) presented as an ideal model for humanity?",
    answer: "Aap (SAW) ko is liye ideal model kaha jata hai kyun ke aap ki life belief aur action ka perfect combination thi. Aap ne sirf teachings nahi di balki un par practically amal karke insaniyat ke liye example set ki.",
  },
  {
    question: "How did the Holy Prophet (SAW) reform society?",
    answer: "Aap (SAW) ne jahalat, injustice, tribal pride aur moral corruption ke society ko truth, equality, brotherhood aur justice ki taraf guide kiya. Aap ki teachings ne social, moral aur spiritual transformation paida ki.",
  },
  {
    question: "What does the lesson show about the Prophet's sense of justice and mercy?",
    answer: "Lesson dikhata hai ke Rasoolullah (SAW) justice me balanced aur mercy me unmatched thay. Aap ne oppressed ka side liya, disputes wisely solve kiye aur even enemies ke sath forgiveness aur generosity ka behavior show kiya.",
  },
  {
    question: "Why is Hijrah important in the lesson's wider message?",
    answer: "Hijrah sirf migration nahi thi balkeh mission ko protect karne aur ek just society build karne ka decisive step thi. Madinah me Islam ke social principles, brotherhood aur collective order practical form me nazar aaye.",
  },
  {
    question: "What is the significance of the Madinah society in this unit?",
    answer: "Madinah society is unit me is liye important hai kyun ke yahan Islam sirf individual belief nahi raha balki brotherhood, justice, consultation aur social harmony par mabni communal order me nazar aaya. Is phase se aap (SAW) ki leadership ka practical dimension samajh aata hai.",
  },
  {
    question: "What does the conquest of Makkah show about the Prophet's leadership?",
    answer: "Conquest of Makkah aap (SAW) ki mercy, restraint aur moral greatness ko show karta hai. Victory ke waqt revenge ke bajaye forgiveness ka choice lesson ke central values ko strongly prove karti hai.",
  },
  {
    question: "Why is the Farewell Sermon important in understanding the Prophet's message?",
    answer: "Farewell Sermon Islam ke core human values ko summarize karta hai: equality, dignity, justice aur brotherhood. Is se pata chalta hai ke aap ka mission sirf religious preaching nahi balki complete human guidance tha.",
  },
  {
    question: "What message of equality is emphasized in the Farewell Sermon?",
    answer: "Farewell Sermon yeh emphasize karta hai ke race, tribe aur background ki bunyaad par superiority valid nahi. Real honor righteousness aur good conduct se aata hai, na ke lineage se.",
  },
  {
    question: "What can students learn from this lesson?",
    answer: "Students honesty, discipline, compassion, fairness aur practical character-building ka lesson seekh sakte hain. Yeh unit batati hai ke real greatness noble conduct aur service to humanity me hoti hai.",
  },
];

const mcqs = [
  {
    question: "Which quality of the Holy Prophet (SAW) is especially emphasized before Prophethood?",
    options: [
      { label: "a", text: "wealth", verdict: "incorrect", reason: "Lesson ka stress material status par nahi balki character par hai." },
      { label: "b", text: "truthfulness and trustworthiness", verdict: "correct", reason: "Aap (SAW) ko Al-Sadiq aur Al-Amin ke titles isi quality ki wajah se mile." },
      { label: "c", text: "political ambition", verdict: "incorrect", reason: "Lesson prophetic mission aur moral leadership ki baat karta hai, worldly ambition ki nahi." },
      { label: "d", text: "tribal pride", verdict: "incorrect", reason: "Islam ne tribal pride ko challenge kiya, emphasize nahi kiya." },
    ],
  },
  {
    question: "What does the lesson especially show about the Prophet's mission?",
    options: [
      { label: "a", text: "It was limited to one tribe only.", verdict: "incorrect", reason: "Lesson universal guidance aur humanity-wide model ki baat karta hai." },
      { label: "b", text: "It focused on moral and social reform along with spiritual guidance.", verdict: "correct", reason: "Unit ka central message truth, justice, equality aur reform ko combine karta hai." },
      { label: "c", text: "It avoided justice and social issues.", verdict: "incorrect", reason: "Justice aur social reform lesson ke main points me se hain." },
      { label: "d", text: "It was based on political domination.", verdict: "incorrect", reason: "Lesson moral leadership aur compassion ko stress karta hai, domination ko nahi." },
    ],
  },
  {
    question: "Why is the Farewell Sermon important in the lesson?",
    options: [
      { label: "a", text: "It summarizes equality, dignity, and brotherhood.", verdict: "correct", reason: "Farewell Sermon ko unit me human values ke concise summary ke tor par present kiya gaya hai." },
      { label: "b", text: "It only discusses trade matters.", verdict: "incorrect", reason: "Lesson isay narrow economic speech ke tor par present nahi karta." },
      { label: "c", text: "It rejects mercy and forgiveness.", verdict: "incorrect", reason: "Mercy aur justice prophetic message ke core parts hain." },
      { label: "d", text: "It limits guidance to one era only.", verdict: "incorrect", reason: "Lesson universal and lasting guidance ka point banata hai." },
    ],
  },
];

const answerBuilding = [
  "Character answer me Al-Sadiq, Al-Amin, justice aur mercy ke points zaroor mention karo.",
  "Mission wale jawab me social reform, equality aur moral transformation ko connect karo.",
  "Farewell Sermon ya universal guidance ke answer me brotherhood, dignity aur justice ka summary dena strong hota hai.",
  "Agar short answer early life se related ho to orphanhood, honesty aur moral maturity ko ek flow me likho.",
  "Conquest of Makkah ya mercy wale answer me forgiveness over revenge ka contrast use karo.",
  "Hijrah ya Madinah wale answer me migration ke sath social order aur brotherhood ka point bhi add karo.",
];

usePageSeo({
  title: "Khatam-un-Nabiyeen Hazrat Muhammad Notes | 11th Class English Unit 1",
  description: "11th class English Unit 1 Khatam-un-Nabiyeen Hazrat Muhammad notes with reading answers, character points, mission, Hijrah, Madinah society and Farewell Sermon coverage.",
  keywords: "khatam-un-nabiyeen hazrat muhammad notes, 11th class english unit 1, class 11 english chapter 1, hazrat muhammad short questions, farewell sermon notes",
  breadcrumbs: [
    { name: "Home", item: "/" },
    { name: "11th English", item: "/11th/english/" },
    { name: "Prose", item: "/11th/english/prose/" },
    { name: "Khatam-un-Nabiyeen Hazrat Muhammad", item: "/11th/english/prose/khatam-un-nabiyeen-hazrat-muhammad/" },
  ],
});
</script>

<template>
  <EnglishLessonPage
    unit="Unit 1"
    title="Khatam-un-Nabiyeen Hazrat Muhammad"
    intro="Yeh page lesson ke character, mission aur universal guidance wale message ko exam prep format me organize karta hai. Is unit ka central focus noble conduct aur moral leadership par hai."
    :bullet-sections="[
      { title: 'Textbook-Aligned Snapshot', items: textbookAlignedPoints },
      { title: 'Unit 1 Coverage Checklist', items: chapterCoverage, layout: 'grid' },
      { title: 'Quick Revision Points', items: quickRevisionPoints },
      { title: 'Source-Backed Focus Areas', items: sourceBackedFocus },
      { title: 'Answer-Building Notes', items: answerBuilding }
    ]"
    :text-sections="[
      { title: 'Reading and Critical Thinking Answers', items: readingQuestions.map((item) => ({ title: item.question, description: item.answer })) }
    ]"
    :mcq-sections="[
      { title: 'MCQ with Option Explanation', items: mcqs }
    ]"
  />
</template>





